import objectToFormData from 'object-to-formdata'

/* eslint-disable no-multi-spaces */
export default class ContactFields {
  constructor (data) {
    this.data = data

    this.mappings = {
      default: {
        retURL: '/tak',
        lead_source: 'Web',
        subject: 'Kontakt fra desmaating.dk',

        email: this.data.email,
        phone: this.data.phone,
        description: this.data.message,
        company: this.data.company,
        debug: process.env.NODE_ENV !== 'production' ? 1 : 0,
        debugEmail: 'thomas@heavyy.io'
      },
      case: {
        orgid: '00D0N000000gtIY',                                                                                       // ORG ID

        name: this.data.name,                                                                                           // Kontakt navn

        '00N0N00000FuYCd': 'De Små Ting',                                                                               // Kategori
        '00N0N00000GvJiE': this.data.department || '',                                                                  // Afdeling
        '00N0N00000GvJiF': this.source1,                                                                                // Kilde 1
        '00N0N00000GvJiG': this.source2                                                                                 // Kilde 2
      },
      lead: {
        oid: '00D0N000000gtIY',                                                                                         // OID

        industry: '',
        first_name: `${this.data.name}`.split(' ').shift(),                                                             // Fornavn
        last_name: `${this.data.name}`.split(' ').slice(1).join(' '),                                                   // Efternavn
        zip: this.data.zip,                                                                                             // Zip

        '00N0N00000FuYEI': this.data.zip,                                                                               // Zip
        '00N0N00000GvJiH': this.data.department || '',                                                                  // Afdeling
        '00N0N00000GvJiP': this.source1,                                                                                // Kilde 1
        '00N0N00000GvJiQ': this.source2                                                                                 // Kilde 2

      }
    }
  }

  entries () {
    return Object.assign(this.mappings.default, this.data.isClient ? this.mappings.case : this.mappings.lead)
  }

  formData () {
    return objectToFormData(this.entries())
  }

  query () {
    let q = []
    const entries = this.entries()

    for (let key in entries) {
      q.push(`${key}=${entries[key]}`)
    }

    return q.join('&')
  }

  get source1 () {
    return window.location.hostname
  }

  get source2 () {
    return 'De Små Ting'
  }

  get endpoint () {
    return this.data.isClient ? this.caseURL : this.leadURL
  }

  get leadURL () {
    return 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
  }

  get caseURL () {
    return 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
  }
}



// WEBPACK FOOTER //
// ./src/library/contact-fields.js